import { viewpointBuilderNavigationOperations } from 'viewpointBuilder/viewpointBuilderNavigation/viewpointBuilderNavigationOperations';
import { initialSearchComponentViewState } from 'viewpointBuilder/selectContextTab/toViewState';
import {
  ViewpointBuilderState,
  ViewpointBuilderViewState,
} from 'viewpointBuilder/types';
import { metamodelViewOperations } from 'viewpointBuilder/metaModel/metamodelViewOperations';
import { getInitialMetaInfoState } from '../viewpointMetaInfo/viewpointMetaInfoOperations';
import { editTraversalOperations } from 'viewpointBuilder/traversals/editTraversalOperations';
import { viewpointGroupingRulesOperations } from 'viewpointBuilder/addGroupingRulesTab/viewpointGroupingRulesOperations';
import { viewpointBuilderFormattingOperations } from 'viewpointBuilder/formattingTabs/viewpointBuilderFormattingOperations';
import { getPrimaryButtonConfig } from './getPrimaryButtonConfig';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { ARDOQ_DEFAULT_LOCALE } from '@ardoq/locale';

export const getInitialViewpointBuilderState = (
  namespace: string
): ViewpointBuilderViewState => {
  const viewpointBuilderState: ViewpointBuilderState = {
    viewpointBuilderNavigationState:
      viewpointBuilderNavigationOperations.getInitialViewModel(),
    searchComponentsState: initialSearchComponentViewState,
    metamodelViewState: metamodelViewOperations.getInitialState(),
    editTraversalsState:
      editTraversalOperations.getInitialTraversalBuilderViewState(),
    metaInfoState: getInitialMetaInfoState(),
    groupingsState: viewpointGroupingRulesOperations.getInitialState(),
    formattingState:
      viewpointBuilderFormattingOperations.getInitialViewState(namespace),
    locale: ARDOQ_DEFAULT_LOCALE,
    // i18nLocale$.state OK here: initial state snapshot for imperative dialog opener, reacts reactively via viewpointBuilder$
    i18nLocale: i18nLocale$.state,
  };
  return {
    ...viewpointBuilderState,
    primaryButtonConfig: getPrimaryButtonConfig(
      viewpointBuilderState,
      namespace
    ),
    namespace,
  };
};
